import { useTranslation } from 'react-i18next';

import { ContentLayout } from '@/components/layouts';

const AdminDashboardRoute = () => {
  const { t } = useTranslation();

  return (
    <ContentLayout title={t('admin.dashboard.title')}>{t('admin.dashboard.welcome')}</ContentLayout>
  );
};

export default AdminDashboardRoute;
